<h2 mat-dialog-title mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.car-rental" | translate }}</h2>

<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Check-in Date -->
      <input-date
        [label]="'Check-in'"
        [required]="true"
        formControlName="checkIn"
        [minDate]="startDate"
        [maxDate]="endDate"
      >
      </input-date>

      <!-- Check-out Date -->
      <input-date
        [label]="'Check-out'"
        [required]="true"
        formControlName="checkOut"
        [minDate]="startDate"
        [maxDate]="endDate"
      >
      </input-date>

      <!-- Vector Name -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.car-rental-vector-name" | translate
        }}</mat-label>
        <input matInput formControlName="vectorName" />
      </mat-form-field>

      <!-- Start Time -->
      <input-time
        formControlName="startTime"
        [required]="true"
        label="start-time"
      ></input-time>

      <!-- End Time -->
      <input-time
        formControlName="endTime"
        [required]="true"
        label="trips.activity.car-rental-end-time"
      ></input-time>

      <!-- Car Type -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.car-rental-car-type" | translate
        }}</mat-label>
        <input matInput formControlName="carType" />
      </mat-form-field>

      <!-- Meeting Point -->
      <input-link
        formControlName="meetingPoint"
        [label]="'trips.activity.car-rental-meeting-point'"
        [required]="true"
        [requiredLabel]="'required-field'"
      ></input-link>

      <!-- Return Point -->
      <input-link
        formControlName="returnPoint"
        [label]="'trips.activity.car-rental-return-point'"
      ></input-link>

      <!-- Transmission Type -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.car-rental-transmission" | translate
        }}</mat-label>
        <mat-select formControlName="transmissionType">
          <mat-option value="manual">{{
            "trips.activity.car-rental-transmission-type-manual" | translate
          }}</mat-option>
          <mat-option value="automatic">{{
            "trips.activity.car-rental-transmission-type-automatic" | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Phone -->
      <input-phone formControlName="phone" [required]="true"></input-phone>

      <!-- Total Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        formControlName="totalPrice"
        label="total-price"
      ></input-monetary-amount>

      <!-- Baggage Number -->
      <input-number
        formControlName="baggageNumber"
        label="trips.activity.car-rental-baggage-number"
        [required]="true"
      ></input-number>

      <!-- Advance Purchase Date -->
      <input-date
        [label]="'advance-purchase-date'"
        [required]="true"
        formControlName="advancePurchaseDate"
        [maxDate]="startDate"
      >
      </input-date>

      <!-- Deposit Amount -->
      <input-monetary-amount
        formControlName="depositAmount"
        label="deposit-amount"
        [required]="true"
      ></input-monetary-amount>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>

      <!-- What Is Included -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{
          "trips.activity.car-rental-what-is-included" | translate
        }}</mat-label>
        <textarea matInput formControlName="whatIsIncluded" rows="3"></textarea>
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="disclaimer"
          rows="3"
          maxlength="500"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
